import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatePickerValue } from '../date-picker/date-picker.component';

export interface DatePickerModalData {
  title?: string;
  value?: DatePickerValue;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
}

@Component({
  selector: 'bhub-date-picker-modal',
  templateUrl: './date-picker-modal.component.html',
  styleUrls: ['./date-picker-modal.component.scss'],
  standalone: false
})
export class DatePickerModalComponent implements OnInit {
  value: DatePickerValue;
  title: string;
  required: boolean;
  minDate?: Date;
  maxDate?: Date;

  constructor(
    public dialogRef: MatDialogRef<DatePickerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DatePickerModalData
  ) {
    this.value = data.value || { mode: 'relative', value: 'today' };
    this.title = data.title || 'Select Date';
    this.required = data.required || false;
    this.minDate = data.minDate;
    this.maxDate = data.maxDate;
  }

  ngOnInit(): void {
    // Initialize with today if no value is set
    if (!this.value.value && this.value.mode === 'relative') {
      this.value.value = 'today';
    }
  }

  onDateChange(value: DatePickerValue): void {
    this.value = value;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.required && !this.value.value) {
      return; // Don't close if required and no value
    }
    this.dialogRef.close(this.value);
  }

  isValid(): boolean {
    if (!this.required) return true;
    return !!this.value.value;
  }
}
